// extracted by mini-css-extract-plugin
export default {"scroll":"order-feed_scroll__OkB-s"};